<template>
  <div
    v-if="vehicleObject"
    class="nopads calendar-item-container"
  >
    <div class="d-flex flex-row w-100">
      <div
        class="contract-header-text"
        :style="{width: '100%', minWidth: textColWidthPercentage + '%'}"
        :class="{expanded: ordersVisible}"
      >
        <font-awesome-icon
          icon="caret-right"
          class="pointer ms-1 me-1"
          style="outline: none"
          :class="{ 'fa-rotate-90': ordersVisible }"
          @click.stop="toggleVehicles(false)"
        />
        <span
          :id="'c_t_'+vehicleObject.id"
          class="ms-2"
          :class="{'disabled-contract' : disableVehicleSelection}"
          @click.stop="$emit('showVehicle', vehicleObject)"
        >
          {{ vehicleObject.license_plate }} - {{ vehicleObject.make }} {{ vehicleObject.vehicle_model ? vehicleObject.vehicle_model : '' }}
        </span>
      </div>
      <div style="min-width: 1127px" />
    </div>
    <div
      v-show="ordersVisible"
      style="display: flex; flex-wrap: wrap;"
    >
      <div
        v-if="loading > 0"
        class="loading-container"
        :style="{width: textColWidthPercentage + '%', borderTop: 'none'}"
      >
        {{ $t('common.loading') }}
      </div>
      <div
        v-else
        style="display: flex; flex-wrap: wrap; align-items: flex-start; width: 100%"
      >
        <!-- Orders -->
        <order-calendar-item
          v-for="order in filteredOrders"
          :key="order.id"
          :order="order"
          :show-all="showAll"
          :show-assignments="false"
          :time-col-width="weekColWidth"
          :visible-weeks-limit="visibleWeeksLimit"
          :calendar-start-date="calendarStartDate"
          :text-col-width-percentage="textColWidthPercentage"
          :calendar-start-week="calendarStartWeek"
          :vehicle-calendar-child="true"
          @show-order="emitShowOrder"
          @order-updated="$emit('orderUpdated')"
        />
        <!-- Add order button -->
        <div class="d-flex flex-row w-100">
          <div
            class="order-text expanded"
            :style="{width: '100%', minWidth: textColWidthPercentage + '%', borderTop: 'none'}"
          >
            <div class="col-12 nopads text-right pr-2 pt-1 pb-1">
              <button
                class="form-button btn btn-success btn-sm"
                @click.stop="emitAddOrder"
              >
                {{ $t('calendar.add_order') }}
              </button>
            </div>
          </div>
          <div style="min-width: 1127px" />
        </div>
      </div>
    </div>
  </div>
</template>


<script>

import {timeUtils} from "@/components/mixins/TimeUtils";
import {restApi} from "@/components/mixins/RestApiMixin";
import {orderMixin} from "@/components/mixins/OrderMixin";
import {workAssignmentHelper} from "@/components/mixins/WorkAssignmentMixin";
import OrderCalendarItem from "@/components/contractcalendar/OrderCalendarItem";

export default {
    name: 'VehicleCalendarItem',
    components: {OrderCalendarItem},
    mixins: [timeUtils, restApi, orderMixin, workAssignmentHelper],
    props: {
        vehicle: {
            type: Object,
            default: null
        },
        textColWidthPercentage: {
            type: Number,
            default: 40
        },
        timeColWidth: {
            type: Number,
            default: 100  // px
        },
        calendarStartDate: {
            type: Date,
            default: null
        },
        visibleWeeksLimit: {
            type: Number,
            default: 20
        },
        calendarStartWeek: {
            type: Number,
            default: 10
        },
        contractFilter: {
            type: Array,
            default() {
                return []
            }
        },
        orderStateFilter: {
            type: Array,
            default() {
                return []
            }
        },
        customerFilter: {
            type: Array,
            default() {
                return []
            }
        },
        autoExpand: {
            type: Boolean,
            default: false
        },
        disableVehicleSelection: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            start: null,
            ordersVisible: false,
            loading: 0,
            vehicleObject: null,
            showAll: false,
            weeks: [],
            orders: [],
            visibleOrders: [],
        }
    },
    computed: {
        weekColWidth() {
            return Math.round(this.timeColWidth / 7) * 7
        },
        filteredOrders() {
            return this.orders.filter(order => {
                const matchesContract =
                    this.contractFilter.length === 0 || this.contractFilter.some(c => c.id === order.contract_task_type.contract.id);
                const matchesCustomer =
                    this.customerFilter.length === 0 || this.customerFilter.some(c => c.id === order.contract_task_type.contract.customer.id);
                const matchesState = !this.orderStateFilter || this.orderStateFilter.length < 1 || this.orderStateFilter.some( c => c === order.status)
                return matchesContract && matchesCustomer && matchesState;
            });
        },
    },
    watch: {
        calendarStartDate: function () {
            this.initTable()
        },
        calendarStartWeek: function () {
            this.initTable()
        },
    },
    mounted: function () {
        this.vehicleObject = this.vehicle
        this.initTable();
        if (this.autoExpand) {
            this.toggleVehicles();
        }
    },
    methods: {
        initTable() {
            this.weeks = []
            this.start = this.calendarStartWeek;
            let startWeek = this.start
            for (let i = 0; i < this.visibleWeeksLimit; i++) {
                this.weeks.push(this.$t('calendar.wk_prefix') + (startWeek+i))
            }
        },
        toggleVehicles(showAll = false) {
            this.ordersVisible = !this.ordersVisible
            this.showAll = showAll
            if (this.ordersVisible) {
                this.fetchOrders()
            }
        },
        fetchOrders: function () {
            this.loading++
            this.orders = []
            this.restFetch(this.vehicleOrderAllocationUrl + '/' + this.vehicleObject.id, this.handleOrders)
        },
        handleOrders: function (response) {
            this.loading--
            if (response != null) {
                this.orders = response.data
            }
        },
        refreshVehicle(vehicle) {
            this.vehicleObject = vehicle
            this.fetchOrders()
        },
        emitShowOrder(order) {
            this.$emit('showOrder', order, this.vehicleObject)
        },
        emitAddOrder() {
            this.$emit('addOrder', this.vehicleObject)
        },
    }
}
</script>
<style scoped>
.calendar-item-container {
    user-select: none;
    white-space: nowrap;
}

.expanded {
    background: #ffffff !important;
}

.contract-header-text, .week-item, .order-text {
    display: inline-block;
    background: #ffffff;
    border-right: 1px #BCBCBC solid;
    margin: 0;
    padding: .1em;
    font-size: .9em;
    user-select: none;
    min-height: 2em;
}

.order-text {
    border-top: 1px #BCBCBC solid;
}

.order-text {
    color: #404041;
    padding-left: 2.2em;
}

.contract-header-text:hover {
    font-weight: bold;
    background: #f6f5f1;

    &:hover {
        color: #007BFF;
        font-weight: bold;
        cursor: pointer;
    }
}

.disabled-contract {
    color: #404041 !important;
    cursor: default;
}

.week-item {
    color: #FFFFFF;
    user-select: none;
    padding: .1em;
}

.loading-container {
    padding: .5em;
    background: #ffffff;
    margin: 0;
}

.dropdown-adder {
    padding-top: 0;
    padding-bottom: 0;
    max-height: 1.4em;
}


</style>
